import { createFileRoute } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { RegisterJuror } from '../components/RegisterJuror';
import { getAuthStore } from '../main';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/juror-registration')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
  },
  component: JurorRegistration,
});

function JurorRegistration() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <Pane classes={'sp-register'} tag="main">
          <RegisterJuror />
        </Pane>
      </div>
    </>
  );
}
